import { render } from "./Item.vue?vue&type=template&id=83104220&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=83104220&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-83104220"

export default script